<template>
  <div class="header">
    <div class="nav-top hidebox">
      <div class="logo">
        <div class="tips">
          <img
            src="../assets/images/logo_bjd.png"
            alt=""
          >
        </div>
        <div class="search">
          <input
            type="text"
            placeholder="搜索实验课程"
            v-model="searchVal"
            @keydown.enter="search"
          >
          <i
            class="iconfont"
            @click="search"
          >&#xe86e;</i>
        </div>
      </div>

    </div>
    <div class="nav hidebox">
      <div>
        <ul class="nav-list">
          <li>
            <router-link
              :class="cur == 0 ? 'on' : ''"
              to="/"
            >首页</router-link>
          </li>
          <li>
            <router-link
              :class="cur == 1 ? 'on' : ''"
              to="/www/search"
            >实验资源</router-link>
          </li>
          <li>
            <router-link
              :class="cur == 2 ? 'on' : ''"
              to="/www/study"
            >课程学习</router-link>
          </li>
<!--          <li>-->
<!--            <a-->
<!--              :class="cur == 3 ? 'on' : ''"-->
<!--              @click="toMix"-->
<!--            >教研平台</a>-->
<!--          </li>-->
        </ul>
        <div
          class="people"
          v-if="localUser.profile_id"
        >
          <img
            class="pic"
            :src="localUser.avatar?localUser.avatar:'--'"
            :onerror="$store.state.defaultHeadImg"
          >
          <a
            href="javascript:void(0)"
            title="个人中心"
            id="username"
            @click="toProfile"
          >{{ localUser.name }}</a>
          <a
            href="javascript:void(0)"
            id="signOff"
            @click="doLogout"
          >退出</a>
        </div>
        <div
          v-else
          class="user-info"
        >
          <router-link
            to="/login"
            class="to-login"
          >登录</router-link>
<!--          <router-link-->
<!--            to="/register"-->
<!--            class="to-register"-->
<!--          >注册</router-link>-->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'HeaderInfo',
  props: {
    cur: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      isShow: false,
      showHeader: true,
      showBtn: true,
      searchVal: ''
    }
  },
  computed: {
    localUser() {
      return this.$store.state.userInfo
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        this.isShow = false
        if (to.name === 'SearchList' || to.name === 'Backstage') {
          this.showHeader = false
        }
        if (to.name === 'Index') {
          this.showBtn = false
        }
      },
      immediate: true
    }
  },
  methods: {
    getTips() {
      this.$layer.msg('2022年申报暂未开放')
    },
    backPre() {
      this.$router.go(-1)
    },
    search(e) {
      // this.$router.push({ path: '/www/search', query: { n: this.utils.encryptDes(this.searchVal) } })
      window.open('/www/search?n=' + this.utils.encryptDes(this.searchVal))
    },
    // 进入个人中心
    toProfile() {
      this.$router.push('/admin')
    },
    toBackstage() {
      this.$router.push('/www/backstage')
    },
    // 退出
    doLogout() {
    // 退出，清空cookie

      this.$store.commit('setToken', '')

      this.$store.commit('clearUserInfo')

      this.$router.push('/login')
    },
    toMix () {
      if (!this.localUser.profile_id) {
        this.$router.push('/login')
      } else {
        this.$http.get('/redirect_mix/').then((data) => {
          window.open(data.mix_path)
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../assets/css/header.css";

/* .logo {
  background-image: url("../assets/images/logo.png");
}
.logo1 {
  float: left;
  width: 245.5px;
  height: 80px;
  background: url("../assets/images/logo_skd.svg") no-repeat 50%;
  background-size: 100%;
  margin-left: 4.2%;
} */
.nav_active {
  width: auto;
  padding: 0 40px;
}
.nav-list_active {
  width: auto;
  padding: 0 10px;
}
.logo {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .search {
    width: 260px;
    height: 30px;
    border: 1px solid #c9c9c9;
    border-radius: 20px;

    overflow: hidden;
    input {
      width: 80%;
      height: 100%;
      border: none;
      outline: none;
      padding-left: 10px;
      background: none;
    }
    i {
      cursor: pointer;
    }
  }
}
.nav {
  & > div {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.to-register {
  color: #fff;
}
</style>
